import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './CoreValues.css';

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const UserCheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <polyline points="17 11 19 13 23 9" />
  </svg>
);

const LightbulbIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="9.6" y1="20" x2="14.4" y2="20" />
    <path d="M12 2c4.4 0 8 3.1 8 7 0 2.2-1.1 4.1-2.8 5.4-.7.5-1.2 1.4-1.2 2.6V18H8v-1c0-1.2-.5-2.1-1.2-2.6C5.1 13.1 4 11.2 4 9c0-3.9 3.6-7 8-7z" />
  </svg>
);

const AwardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="7" />
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
  </svg>
);

export function CoreValues() {
  const { t, language } = useLanguage();
  const isRtl = language === 'ar';

  const values = [
    { icon: <ShieldIcon />, title: t('coreValues.v1Title'), desc: t('coreValues.v1Desc') },
    { icon: <UserCheckIcon />, title: t('coreValues.v2Title'), desc: t('coreValues.v2Desc') },
    { icon: <LightbulbIcon />, title: t('coreValues.v3Title'), desc: t('coreValues.v3Desc') },
    { icon: <AwardIcon />, title: t('coreValues.v4Title'), desc: t('coreValues.v4Desc') }
  ];

  return (
    <section className="lux-cv-sec" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="lux-cv-container">
        
        <div className="lux-cv-header">
          <div className="lux-cv-pre">
            <span className="lux-cv-dash"></span>
            {isRtl ? 'مبادئنا' : 'Our Principles'}
          </div>
          <h2 className="lux-cv-main-title">{t('coreValues.title')}</h2>
          <p className="lux-cv-subtitle">{t('coreValues.subtitle')}</p>
        </div>

        <div className="lux-cv-grid">
          {values.map((val, idx) => (
            <div key={idx} className="lux-cv-card">
              <div className="lux-cv-number">0{idx + 1}</div>
              <div className="lux-cv-icon-box">
                <div className="lux-cv-icon-inner">{val.icon}</div>
                <div className="lux-cv-icon-glow"></div>
              </div>
              <h3 className="lux-cv-card-title">{val.title}</h3>
              <div className="lux-cv-card-line"></div>
              <p className="lux-cv-card-desc">{val.desc}</p>
              <div className="lux-cv-card-border"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
